@if (eligibility(); as eligibility) {
  @if (eligibility.allowed) {
    <button
      mat-stroked-button
      class="establish"
      data-tour-anchor="contract.establish-amendment"
      (click)="establish()"
    >
      <svg lucideFilePenLine></svg>
      Établir un avenant
    </button>
  } @else {
    <span
      class="unavailable"
      data-tour-anchor="contract.establish-amendment"
      [matTooltip]="eligibility.refusal ?? ''"
      tabindex="0"
    >
      <svg lucideFilePenLine></svg>
      Établir un avenant
      <mat-icon class="info" aria-label="Pourquoi ?">info</mat-icon>
    </span>
  }
}
